export default {
  validation: {
    required: 'Dies ist eine erforderliche Frage',
    kana_format: 'Tippen Sie in Katakana',
    email_format: '@.lower:validation.variables.email ist nicht korrekt',
    date_format: 'Tippen Sie in @.lower:validation.variables.date',
    number_format: 'Tippen Sie in @.lower:validation.variables.number',
    halfwidth_number_format: 'Geben Sie nur halb so breite Ziffern ein',
    alphanumeric_format: 'Tippen Sie in @.lower:validation.variables.alphanumeric ',
    postal_number_no_hyphen: 'Tippen Sie in @.lower:validation.variables.postal_number',
    postal_number_format: 'Tippen Sie in @:validation.variables.postal_number',
    login_email_required: '@:validation.required',
    login_email_format: '@:validation.email_format',
    login_password_required: '@:validation.required',
    // login_password_format: "",
    // min_length: "",
    // max_length: "",
    // greater_than_or_equal_number: "",
    // greater_than_number: "",
    // less_than_or_equal_number: "",
    // less_than_number: "",
    max_digit: 'Bitte geben Sie bis zu {digit} Ziffern ein.',
    max_digit_with_item: 'Bitte geben Sie {item} innerhalb von {digit} Ziffern ein',
    // number_only: "",
    // decimal_max_digit: "",
    no_blank_or_newline: 'Die Beantwortung nur mit Leerzeichen und/oder Zeilenumbrüchen ist nicht erlaubt.',
    // invalid_zero_number: "",
    variables: {
      id_or_email: 'ID/E-Mail-Adresse',
      email: 'E-Mail Adresse',
      password: 'Passwort',
      kana: '',
      date: 'Datum (z.B. 31/01/2023)',
      number: 'Nummer',
      alphanumeric: 'Alphabet und Zahlen',
      postal_number: 'Postleitzahl',
    },
  },
}
